import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import { toFieldsNames, toMobxFields } from './MobxFormGenerator';
const fieldsProps = {
    legacyApiPartner: {
        type: 'text',
        label: '',
        rules: ['required'],
        extra: [],
        options: {
            validateOnChange: true
        }
    }
};
const fieldsNames = toFieldsNames(fieldsProps);
const options = {
    validateDisabledFields: true
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const form = new MobxReactForm({ fields: toMobxFields(fieldsProps) }, { options, plugins });
export { fieldsNames };
export default form;
